export class VbaTraceItem {
}
